import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export class About {
  constructor() {
    this.section = document.querySelector('.p-index_about')
    if (!this.section) return
    this.items = this.section.querySelectorAll('.p-index_about__gallery .image-item')
    if (!this.items.length) return
    this.init()
  }

  init() {
    this.items.forEach((item, i) => {
      // data-speed が未指定なら index に応じて変化を付ける（0.4 / 0.8 / 1.2 を循環）
      const speed = parseFloat(item.dataset.speed)
      const factor = isNaN(speed) ? 0.4 + (i % 3) * 0.4 : speed

      gsap.fromTo(
        item,
        { y: () => window.innerHeight * 0.15 * factor },
        {
          y: () => -window.innerHeight * 0.15 * factor,
          ease: 'none',
          scrollTrigger: {
            trigger: this.section,
            start: 'top bottom',
            end: 'bottom top',
            scrub: true,
            invalidateOnRefresh: true,
          },
        },
      )
    })
  }
}
